<template>
    <div class="medical_case">
        <Navbar />
        <v-content>
            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 md3 v-if="medicalCase.name">
                        <h3>Name of Medical Case</h3>
                        <p>{{medicalCase.name}}</p>
                    </v-flex>
                    <v-flex xs12 md2 v-if="medicalCase.surgical != null">
                        <h3>Surgical</h3>
                        <v-icon v-if="medicalCase.surgical">done</v-icon>
                        <v-icon v-if="!medicalCase.surgical">clear</v-icon>
                    </v-flex>
                    <v-flex xs12 md2 v-if="medicalCase.hospitalisation != null">
                        <h3>Need of Hospitalisation</h3>
                        <v-icon v-if="medicalCase.hospitalisation">done</v-icon>
                        <v-icon v-if="!medicalCase.hospitalisation">clear</v-icon>
                    </v-flex>
                    <v-flex xs12 md2 v-if="medicalCase.usar != null">
                        <h3>USAR</h3>
                        <v-icon v-if="medicalCase.usar">done</v-icon>
                        <v-icon v-if="!medicalCase.usar">clear</v-icon>
                    </v-flex>
                    <v-flex xs12 md2 v-if="medicalCase.medivac != null">
                        <h3>MEDIVAC</h3>
                        <v-icon v-if="medicalCase.medivac">done</v-icon>
                        <v-icon v-if="!medicalCase.medivac">clear</v-icon>
                    </v-flex>
                    <v-flex xs12 md3 v-if="medicalCase.triage != null">
                        <h3>Triage</h3>
                        <p>{{triageLevels[medicalCase.triage]}}</p>
                    </v-flex>
                    <v-flex xs12 md8 v-if="medicalCase.short_summary">
                        <h3>Short Summary</h3>
                        <p>
                            <pre>{{medicalCase.short_summary}}</pre>
                        </p>
                    </v-flex>
                    <v-flex xs12 md6 v-if="hasMedicalHistory">
                        <h3>Medical History</h3>
                        <p v-if="medicalCase.history.problems"><b>Problems/Conditions:</b>
                            {{medicalCase.history.problems}}</p>
                        <p v-if="medicalCase.history.vaccinations"><b>Vaccinations:</b>
                            {{medicalCase.history.vaccinations}}</p>
                        <p v-if="medicalCase.history.allergies"><b>Allergies:</b> {{medicalCase.history.allergies}}</p>
                        <p v-if="medicalCase.history.medication"><b>Medication:</b> {{medicalCase.history.medication}}</p>
                        <p v-if="medicalCase.history.implantable_devices"><b>Implantable Devices:</b>
                            {{medicalCase.history.implantable_devices}}</p>
                    </v-flex>
                    <v-flex xs12 md6 v-if="medicalCase.gender || medicalCase.age_span || medicalCase.general_condition">
                        <h3>Patient Presentation on Arrival</h3>
                        <p v-if="medicalCase.nationality"><b>Nationality:</b> {{medicalCase.nationality}}</p>
                        <p v-if="medicalCase.gender"><b>Gender:</b> {{medicalCase.gender}}</p>
                        <p v-if="medicalCase.age_span"><b>Age:</b> {{medicalCase.age_span}}</p>
                        <p v-if="medicalCase.general_condition"><b>General Condition:</b>
                            <pre>{{medicalCase.general_condition}}</pre>
                        </p>
                    </v-flex>
                    <v-flex xs12 v-if="hasVitalSigns">
                        <h3>Vital Signs</h3>
                        <v-content>
                            <v-container>
                                <v-layout row wrap>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.onset_of_symptoms">
                                        <h3>Onset of Symptoms</h3>
                                        <p>{{medicalCase.vital_signs.onset_of_symptoms}}</p>
                                    </v-flex>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.AVPU">
                                        <h3>AVPU</h3>
                                        <p>{{medicalCase.vital_signs.AVPU}}</p>
                                    </v-flex>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.mobility">
                                        <h3>Mobility</h3>
                                        <p>{{medicalCase.vital_signs.mobility}}</p>
                                    </v-flex>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.respiratory_rate">
                                        <h3>Respiratory Rate</h3>
                                        <p>{{medicalCase.vital_signs.respiratory_rate}}</p>
                                    </v-flex>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.pulse_rate">
                                        <h3>Pulse Rate</h3>
                                        <p>{{medicalCase.vital_signs.pulse_rate}}</p>
                                    </v-flex>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.temperatur">
                                        <h3>Temperatur</h3>
                                        <p>{{medicalCase.vital_signs.temperatur}}</p>
                                    </v-flex>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.capillary_refill">
                                        <h3>Capillary Refill</h3>
                                        <p>{{medicalCase.vital_signs.capillary_refill}}</p>
                                    </v-flex>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.blood_presure">
                                        <h3>Blood Pressure</h3>
                                        <p>{{medicalCase.vital_signs.blood_presure}}</p>
                                    </v-flex>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.oxygen_saturation">
                                        <h3>Oxygen Saturation</h3>
                                        <p>{{medicalCase.vital_signs.oxygen_saturation}}</p>
                                    </v-flex>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.weight">
                                        <h3>Weight</h3>
                                        <p>{{medicalCase.vital_signs.weight}}</p>
                                    </v-flex>
                                    <v-flex xs3 v-if="medicalCase.vital_signs.height">
                                        <h3>Height</h3>
                                        <p>{{medicalCase.vital_signs.height}}</p>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-content>
                    </v-flex>
                    <v-flex xs12 md6 v-if="medicalCase.general_status">
                        <h3>General Status</h3>
                        <p>
                            <pre>{{medicalCase.general_status}}</pre>
                        </p>
                    </v-flex>
                    <v-flex xs12 md6 v-if="medicalCase.on_examination">
                        <h3>On Examination</h3>
                        <p>
                            <pre>{{medicalCase.on_examination}}</pre>
                        </p>
                    </v-flex>
                    <v-flex xs12 md6 v-if="medicalCase.expectations">
                        <h3>Expectations and Outcomes</h3>
                        <p>
                            <pre>{{medicalCase.expectations}}</pre>
                        </p>
                    </v-flex>
                    <v-flex xs12 md6 v-if="medicalCase.makeup">
                        <h3>Needed Make-Up and Attributes</h3>
                        <p>
                            <pre>{{medicalCase.makeup}}</pre>
                        </p>
                    </v-flex>
                    <v-flex xs12 md6 v-if="medicalCase.others">
                        <h3>Other Information</h3>
                        <p>
                            <pre>{{medicalCase.others}}</pre>
                        </p>
                    </v-flex>
                    <v-layout row wrap>
                        <v-flex xs6 md4 lg2 v-for="document in medicalCase.documents" v-bind:key="document.name">
                            <v-card height="100%">
                                <v-icon @click="getDocument(document)">attach_file</v-icon>
                                <v-card-title @click="getDocument(document)">{{document.name}}
                                    ({{bytesToSize(document.bytes)}})</v-card-title>
                                <v-card-actions>
                                    <v-btn flat color="red" @click="deleteDocument(document)">Delete</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-container>
        </v-content>
        <v-snackbar v-model="notExists" :right="true">
            Medical Case can't be loaded.
            <v-btn color="pink" flat @click="notExists = false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import FileDownload from 'js-file-download'
    import Navbar from '@/components/Navbar.vue'
    import axios from 'axios';
    axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

    export default {
        data() {
            return {
                medicalCase: {
                    id: '',
                    name: '',
                    surgical: false,
                    hospitalisation: false,
                    usar: false,
                    medivac: false,
                    triage: 0,
                    short_summary: '',
                    history: {
                        problems: '',
                        vaccinations: '',
                        allergies: '',
                        medication: '',
                        implantable_devices: ''
                    },
                    nationiality: '',
                    age_span: '',
                    gender: 'all',
                    general_condition: '',
                    vital_signs: {
                        onset_of_symptoms: '',
                        AVPU: '',
                        mobility: '',
                        respiratory_rate: null,
                        pulse_rate: null,
                        temperatur: null,
                        capillary_refill: null,
                        blood_presure: null,
                        oxygen_saturation: null,
                        weight: null,
                        height: null
                    },
                    general_status: '',
                    on_examination: '',
                    expectations: '',
                    makeup: '',
                    others: '',
                    documents: []
                },
                notExists: false,
                triageLevels: ["Non Urgent", "Less Urgent", "Urgent", "Emergent", "Resuscitation"],
            }
        },
        components: {
            Navbar
        },
        methods: {
            loadMedicalCase() {
                var mcID = this.$route.params.id
                axios.get('/medical_cases/' + mcID).then(response => {
                    this.medicalCase = response.data
                }).catch(error => {
                    this.notExists = true
                })
            },
            bytesToSize(bytes) {
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                if (bytes === 0) return 'n/a';
                let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                if (i === 0) return bytes + ' ' + sizes[i];
                return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
            },
            deleteDocument(document) {
                if (confirm("Are you sure you want to delete: " + document.name + "?")) {
                    axios.delete('/medical_cases/' + this.medicalCase.id + '/documents/' + document.name).then(
                        response => {
                            this.medicalCase = response.data
                        }).catch(error => {})
                }
            },
            getDocument(document) {
                axios.get('/medical_cases/' + this.medicalCase.id + '/documents/' + document.name, {
                    responseType: 'blob'
                }).then(response => {
                    FileDownload(response.data, document.name, )
                }).catch(error => {})
            }
        },
        mounted() {
            this.loadMedicalCase();
        },
        computed: {
            hasVitalSigns() {
                var keys = Object.keys(this.medicalCase.vital_signs)
                for (var i in keys) {
                    if (this.medicalCase.vital_signs[keys[i]]) {
                        return true
                    }
                }
                return false
            },
            hasMedicalHistory() {
                var keys = Object.keys(this.medicalCase.history)
                for (var i in keys) {
                    if (this.medicalCase.history[keys[i]]) {
                        return true
                    }
                }
                return false
            }
        }
    }
</script>

<style>
    pre {
        font-family: Roboto, sans-serif;
        white-space: pre-wrap;
        /* css-3 */
        white-space: -moz-pre-wrap;
        /* Mozilla, since 1999 */
        white-space: -pre-wrap;
        /* Opera 4-6 */
        white-space: -o-pre-wrap;
        /* Opera 7 */
        word-wrap: break-word;
        /* Internet Explorer 5.5+ */
    }
</style>